import {
    Column,
      Entity,
      Index,
      JoinColumn,
      OneToOne,
      ManyToOne,
      PrimaryGeneratedColumn,
    } from "typeorm";
import { PlatformUser } from "./PlatformUser";

@Index("awarded_badges_pkey", ["id"], {unique: true})
//@Index("badges_unique_idx", ["platform_user_id"])
@Entity("awarded_badges")
export class AwardedBadges {
    @PrimaryGeneratedColumn({type: "bigint", name: "id"})
    id!: number;

    /*@Column({type: "bigint", name: "platform_user_id"})
    platformUserId!: number;*/

    @ManyToOne( (type) => PlatformUser, (platformUser) => platformUser.awardedBadges)
    @JoinColumn([{name: "platform_user_id", referencedColumnName: "id"}])
    platformUser!: PlatformUser

    @Column({type: "text", name: "badge_code"})
    badgeCode!: string;

    @Column({type: "timestamp with time zone", name: "earn_date", nullable: true})
    earnDate: Date | null;

}
